import TheGrid from '@/views/scorecard/results/grid'
import Edit from '@/views/scorecard/results/edit'

export default {
  path: '/scorecard/results',
  redirect: '/scorecard/results/index',
  name: 'scorecard_results',
  meta: {
    auth: {
      redirect: {
        name: 'scorecard_results.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Scorecard'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'scorecard_results.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Resultados'
    }
  }]
}
